// removed by extract-text-webpack-plugin
module.exports = {"collapse_breakpoint":"1090","default_opacity":".85","county_barchart_width":"240","university_barchart_width":"290","county_bar_height":"20","university_bar_height":"35","ethnicity_bar_height":"25","university_circle_radius":"10","mapwidth":"350","mapheight":"570"};


//////////////////
// WEBPACK FOOTER
// ./index.scss
// module id = 2
// module chunks = 0